import { ANIMATION_MODULE_TYPE, Component, Inject } from '@angular/core';
import { MatCard, MatCardAppearance, MatCardConfig } from '@angular/material/card';

@Component({
  selector: 'abc-card',
  template: `<ng-content></ng-content>`,
  standalone: true,
})
export class _AbcCardComponent extends MatCard {
  constructor(@Inject(ANIMATION_MODULE_TYPE) _animationMode?: string | undefined) {
    const animationMode: MatCardConfig = { appearance: _animationMode as MatCardAppearance };
    super(animationMode);
  }
}
